import { AdminInput, AdminToggle, AdminSectionCard } from './AdminFormInput';
import type { TemplateConfig } from '@/mocks/template-config';

interface SpecialtiesFormProps {
  specialties: TemplateConfig['specialties'];
  onChange: (specialties: TemplateConfig['specialties']) => void;
}

export default function SpecialtiesForm({ specialties, onChange }: SpecialtiesFormProps) {
  const updateSpecialty = (index: number, updates: Partial<TemplateConfig['specialties'][0]>) => {
    const newSpecs = [...specialties];
    newSpecs[index] = { ...newSpecs[index], ...updates };
    onChange(newSpecs);
  };

  const moveUp = (index: number) => {
    if (index === 0) return;
    const newSpecs = [...specialties];
    const temp = newSpecs[index].order;
    newSpecs[index].order = newSpecs[index - 1].order;
    newSpecs[index - 1].order = temp;
    onChange(newSpecs);
  };

  const moveDown = (index: number) => {
    if (index === specialties.length - 1) return;
    const newSpecs = [...specialties];
    const temp = newSpecs[index].order;
    newSpecs[index].order = newSpecs[index + 1].order;
    newSpecs[index + 1].order = temp;
    onChange(newSpecs);
  };

  const sorted = [...specialties].sort((a, b) => a.order - b.order);

  return (
    <div className="space-y-5">
      <AdminSectionCard title="Especialidades" icon="ri-star-line">
        <div className="space-y-3">
          {sorted.map((spec, index) => {
            const originalIndex = specialties.findIndex((s) => s.name === spec.name);
            return (
              <div
                key={spec.name}
                className="flex items-center gap-3 bg-brand-dark/40 border border-brand-gold/10 rounded-md p-3"
              >
                <div className="flex flex-col gap-1">
                  <button
                    onClick={() => moveUp(originalIndex)}
                    className="w-6 h-6 flex items-center justify-center text-brand-text-muted hover:text-brand-gold transition-colors cursor-pointer"
                    disabled={index === 0}
                  >
                    <i className="ri-arrow-up-s-line text-sm" />
                  </button>
                  <button
                    onClick={() => moveDown(originalIndex)}
                    className="w-6 h-6 flex items-center justify-center text-brand-text-muted hover:text-brand-gold transition-colors cursor-pointer"
                    disabled={index === sorted.length - 1}
                  >
                    <i className="ri-arrow-down-s-line text-sm" />
                  </button>
                </div>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${spec.icon} text-brand-gold text-sm`} />
                </div>
                <div className="flex-1 min-w-0">
                  <input
                    type="text"
                    value={spec.name}
                    onChange={(e) => updateSpecialty(originalIndex, { name: e.target.value })}
                    className="w-full bg-transparent text-brand-text text-sm focus:outline-none"
                  />
                </div>
                <input
                  type="text"
                  value={spec.icon}
                  onChange={(e) => updateSpecialty(originalIndex, { icon: e.target.value })}
                  className="w-32 bg-brand-dark/60 border border-brand-gold/20 rounded-md py-1.5 px-2 text-brand-text text-xs focus:outline-none focus:border-brand-gold/50"
                  placeholder="ri-camera-line"
                />
                <button
                  onClick={() => updateSpecialty(originalIndex, { active: !spec.active })}
                  className={`w-8 h-8 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
                    spec.active ? 'bg-brand-gold/20 border-brand-gold/40 text-brand-gold' : 'bg-brand-dark/40 border-brand-gold/10 text-brand-text-muted'
                  }`}
                  title={spec.active ? 'Ativo' : 'Inativo'}
                >
                  <i className={`${spec.active ? 'ri-eye-line' : 'ri-eye-off-line'} text-sm`} />
                </button>
                <span className="text-brand-text-muted text-xs w-8 text-center">{spec.order}</span>
              </div>
            );
          })}
        </div>
      </AdminSectionCard>
    </div>
  );
}